/**
 * Standing notice that this board is a sandbox.
 *
 * Says plainly that nothing is saved to an account, because the board otherwise
 * behaves exactly like a real one and it would be unkind to let someone put an
 * afternoon into it under a misapprehension. The way out is the same click that
 * keeps the work.
 */
export function DemoBanner({ accent, onKeep, onReset }: { accent: string; onKeep: () => void; onReset: () => void }) {
  return (
    <div className="sp-demo-banner" role="status">
      <div className="sp-demo-copy">
        <strong>You're in the demo — make it yours</strong>
        <span className="sp-demo-detail">Stored in this browser. Keep it when you're ready.</span>
      </div>
      <button className="sp-button" aria-label="Reset the demo board" onClick={onReset}>
        Reset
      </button>
      <button className="sp-button sp-primary" onClick={onKeep}>
        Keep this board
      </button>
    </div>
  );
}
